var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { html, css } from 'lit';
import { live } from 'lit/directives/live.js';
import { customElement, PICInputOptions, stringDecoder } from '../Internals';
let PICText = class PICText extends PICInputOptions {
    set exclude(iExclude) {
        this.exclude_ = atob(iExclude);
    }
    get exclude() {
        return btoa(this.exclude_);
    }
    get submitValue() {
        return this.inputField.value;
    }
    get isLookupField() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.actionElm) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.indexOf('lookupaction')) !== null && _c !== void 0 ? _c : -1) > -1;
    }
    constructor() {
        super();
        this.isInputCycle = false;
    }
    static get styles() {
        const defaultStyle = css `
          .inner-input-old {
            box-sizing: border-box;
            font-family: monospace;
          }
          
          input {
            -webkit-user-select: auto;
            -webkit-user-drag: none;
            user-select: auto;
          }
          .inner-input::placeholder {
            opacity: 0.5;
          }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.eType == 'default' ? this.eType = 'text' : this.eType = 'old';
        //Catches browser auto-fill and moves the label
        // setTimeout(() => {
        //     let hasBeenAutoFilled = this.inputField.matches('input:-internal-autofill-selected') //chrome
        //     || this.inputField.matches('input:-webkit-autofill') //webkit
        //     if (hasBeenAutoFilled) {
        //         this.focusHandler('in')
        //         this.requestUpdate()
        //     }
        // }, 200)
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        //set cursor position post update
        if (this.savedCaretPos !== null)
            if ((this.inputField.type == 'text' || this.inputField.type == 'password') && this.isInputCycle)
                this.inputField.setSelectionRange(this.savedCaretPos, this.savedCaretPos);
        this.isInputCycle = false;
        //update value
        if (this.value !== '') {
            this.density == 'low' && this.inputLabel.classList.contains('low') ? this.inputLabel.classList.remove('low') : '';
            this.density == 'medium' && this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.remove('medium') : '';
        }
    }
    willUpdate(_changedProperties) {
        super.willUpdate(_changedProperties);
        //only do work if after first render
        if (this.inputField && this.isInputCycle) {
            // skip if in selectors etc.
            if (this.inputField.type == 'text' || this.inputField.type == 'password') {
                let newValue = this.inputField.value;
                this.savedCaretPos = this.inputField.selectionStart;
                if (this.exclude_) {
                    // save newValue in tmp for cursor placement 
                    let tmpVal = newValue.replace(new RegExp(this.exclude_, 'g'), '');
                    if (tmpVal.length != newValue.length) {
                        // calculate new correct cursor placement. 
                        this.savedCaretPos -= (newValue.length - tmpVal.length);
                    }
                    newValue = tmpVal;
                }
                this.value = newValue;
                this.setHasEllipsis();
            }
        }
    }
    focus() {
        this.inputField.focus();
    }
    doNothing(e) {
        return false;
    }
    inputHandler(e) {
        this.isInputCycle = true;
        this.validate();
    }
    validate() {
        super.validate();
    }
    changeHandler(e) {
        return super.changeHandler(e);
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        // if(this.eType !== 'old') this.decodeInitTextVal();
        this.initValue_ = this.submitValue;
        if (this.inputLabel && this.submitValue.length > 0) {
            this.density == 'low' && this.inputLabel.classList.contains('low') ? this.inputLabel.classList.remove('low') : '';
            this.density == 'medium' && this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.remove('medium') : '';
        }
        this.adjustRenderedWidth();
        this.requestUpdate();
    }
    focusHandler(mode) {
        if (this.inputLabel) {
            if (mode == 'in') {
                this.density == 'low' && this.inputLabel.classList.contains('low') ? this.inputLabel.classList.remove('low') : '';
                this.density == 'medium' && this.inputLabel.classList.contains('medium') ? this.inputLabel.classList.remove('medium') : '';
                this.showFullError = true;
                this.requestUpdate();
            }
            if ((mode == 'out' && this.submitValue.length === 0) && (this.placeholder === null || this.placeholder.length === 0)) {
                //Float label back down, unless value or placeholder is sat
                this.density == 'low' ? this.inputLabel.classList.toggle('low') : '';
                this.density == 'medium' ? this.inputLabel.classList.toggle('medium') : '';
                this.showFullError = false;
                this.requestUpdate();
            }
        }
        // let errorContainer = this.shadowRoot?.querySelector('pic-error') as HTMLElement
        // console.log('text..', errorContainer)
        if (mode == 'in') {
            this.showFullError = true;
            this.requestUpdate();
        }
        if (mode == 'out') {
            this.showFullError = false;
            this.requestUpdate();
        }
    }
    handleKeyUp(e) {
        if (e.key === 'Enter') {
            this.enterSubmit(e);
        }
        else if (this.isLookupField && e.key === ' ' && e.ctrlKey && this.actionElm) {
            this.actionElm.triggerEvent(e);
        }
        else
            this.keyHandler(e);
    }
    render() {
        var _a, _b;
        this.setComponentInlineStyle();
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.getContainerClassMap())}>
                <label class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} for=${this.id_ + '_inner'}>${this.label}</label>
                <input
                    name="${this.id_}"
                    id=${this.id_ + '_inner'}
                    type=${(_a = this.fieldtype) !== null && _a !== void 0 ? _a : 'text'}
                    class=${classMap(this.getInnerInputClass())}
                    ?readonly=${this.readonly_}
                    ?passwordfield=${this.fieldtype === 'password'}
                    autocomplete=${(_b = this.autocomplete) !== null && _b !== void 0 ? _b : 'on'}
                    tabindex=${this.readonly_ ? -1 : 1}
                    placeholder=${this.placeholder}
                    .value=${live(this.value)}
                    @input=${this.inputHandler}
                    @focusin=${() => this.focusHandler('in')}
                    @focusout=${(e) => { this.changeHandler(e); this.focusHandler('out'); }}
                    @drop=${this.doNothing}
                    @dragenter=${this.doNothing}
                    @dragover=${this.doNothing}
                    @keyup=${this.handleKeyUp}
                    @pullback=${this.pullbackHandler}
                    ?disabled=${this.disabled_}
                    title=${this.isLookupField ? '(ctrl-space to open lookup)' : undefined}
                />
                ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
                ${this.renderErrIcon()}
                ${this.renderErr(this.showFullError)}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
            ${!this.tooltip_ && this.hasEllipsis ? html `<pic-tooltip>${this.value}</pic-tooltip>` : ''}
        `;
    }
};
__decorate([
    query('.inner-input')
], PICText.prototype, "inputField", void 0);
__decorate([
    query('.inner-inputLabel')
], PICText.prototype, "inputLabel", void 0);
__decorate([
    property()
], PICText.prototype, "fieldtype", void 0);
__decorate([
    property()
], PICText.prototype, "autocomplete", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'exclude' })
], PICText.prototype, "exclude", null);
PICText = __decorate([
    customElement('pic-text')
], PICText);
export { PICText };
// ?disabled=${this.disabled_}
//# sourceMappingURL=PICText.js.map